'use client'

import { ErrorBoundary } from 'react-error-boundary'
import { CloseIcon } from 'primitives/icons/close'

export function ErrorBoundaryWrapper({ children }: { children: React.ReactNode }) {
  return <ErrorBoundary FallbackComponent={ErrorBoundaryComponent}>{children}</ErrorBoundary>
}

function ErrorBoundaryComponent({ resetErrorBoundary }: { resetErrorBoundary?(): void }) {
  return (
    <div className="flex flex-row items-center gap-4">
      <CloseIcon className="text-cf-dreamy-cloud-1000 border-cf-dreamy-cloud-1000 aspect-square size-24 rounded-full border-4" />
      <div className="flex h-full w-full flex-1 flex-col items-start justify-center p-3">
        <p className="mb-3 w-full max-w-[420px] text-balance text-gray-50">
          <span className="mb-3 inline-block font-bold">Oops, something went wrong!</span>
          <br /> Please refresh the page or get in touch if this happens again.
        </p>
        {resetErrorBoundary ? (
          // oxlint-disable-next-line react/button-has-type
          <button
            className="bg-cf-white rounded-2 hover:shadow-cf-elevation-light-1 border border-[#DFDDE5] p-2 px-4"
            onClick={resetErrorBoundary}
          >
            Retry
          </button>
        ) : null}
      </div>
    </div>
  )
}
